import React, {Component, Fragment} from 'react';
import {Link, Redirect} from "react-router-dom";
import {Button, Card, CardHeader, CardTitle, Col, Input, Label, Row} from "reactstrap";
import DataTable from "react-data-table-component";
import {connect} from "react-redux";
import {actionDeleteUserById, actionGetAgentsByRoll, getChatList, UpdateGroupBackend} from "../../actions/profile";
import swal from "sweetalert";
import image from "../../assets/img/Logo/1.png"
import {logoutAdmin} from "../../actions/auth";
import Spinner from "../layout/Spinner";
import CommanSidebar from '../common/commanSidebar';
import ToggleSwitch from "../common/Button/toggleSwitch";

class Groups extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData: true,
            q: '',
            offset: '',
            limit: '',
            searchValue: '',
            errors: {},
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = "Users | Prime Private Network";
        const request = {
            q: this.state.q,
            offset: this.state.offset,
            limit: this.state.limit
        };
        this.props.actionGetAgentsByRoll(request);
        this.props.getChatList(this.props.user._id);

        if (this.props.isAuthenticatedAdmin && this.props.user.role.name === "Admin") {
            return <Redirect to="/users"/>;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.chatLists !== this.props.chatLists) {
            this.setState({allUsers: this.props.chatLists});
            /* const request = {
                 q :this.state.q,
                 offset :this.state.offset,
                 limit:this.state.limit
             };
             this.props.actionGetAgentsByRoll(request);*/
        }
    }

    onChangeStatus = (id) => {
        const data = this.props.chatLists && this.props.chatLists.find(f => f._id === id);
        console.log(data);
        const req = {
            //name: data.name,
            //user: this.props.user._id,
            //image: data.image,
            //group_owner: data.group_owner._id,
            status: data.status === 0 ? 1 : 0,
            //members: data.members,
        };
        this.props.UpdateGroupBackend(id, req, () => this.props.getChatList(this.props.user._id));
    };

    render() {
        const columns = [
            {
                name: "Group Name",
                selector: "name",
                sortable: true,
                center: true
            },
            {
                name: "Group Owner",
                selector: "group_owner.name",
                sortable: true,
                center: true
            },
            {
                name: "Status",
                selector: "status",
                sortable: true,
                right: true,
                cell: row => (
                    <div className="group-toggle">
                        <ToggleSwitch
                            checked={row.status === 1}
                            text={row.status === 0 ? 'Deactive' : 'Active'}
                            size={'default'}
                            onChange={() => this.onChangeStatus(row._id)}
                            offstyle="btn-custom-3"
                            onstyle="btn-custom-1"
                        />
                    </div>

                )
            },
            {
                name: "Image",
                selector: "image",
                sortable: true,
                right: true,
                cell: row => (
                    <img
                        src={row.image}
                        width={'40px !important'}
                        className={'cell-image'}
                        alt='Player'
                    />
                )
            },
        ];
        return (
            <Fragment>
                <CommanSidebar/>
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <Card className="mt-5">
                                <CardHeader
                                    className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                                    <div className='d-flex mt-md-0 mt-1 justify-content-between'>
                                        <CardTitle tag='h4'>Groups</CardTitle>
                                        {/*<Link to="/add-user">*/}
                                        {/*<Button className='ml-2'>*/}
                                        {/*<i className="fa fa-plus"/>*/}
                                        {/*<span className='align-middle ml-50'>Add New User</span>*/}
                                        {/*</Button>*/}
                                        {/*</Link>*/}
                                    </div>
                                </CardHeader>
                                <Row className='justify-content-end mx-0'>
                                    <Col className='d-flex align-items-center justify-content-end mt-1' lg="3" md='3'
                                         sm='12'>
                                        <Label className='mr-1' for='search-input'>
                                            Search
                                        </Label>
                                        <Input
                                            className='dataTable-filter mb-50 '
                                            type='text'
                                            // bsSize='sm'
                                            id='search-input'
                                            // value={searchValue}
                                            // onChange={this.handleFilter}
                                            onChange={(e) => {
                                                let newFilterText = e.target.value;
                                                const agents = this.props.chatLists.filter(
                                                    (item) =>
                                                        (item.name && item.name.toLowerCase().includes(newFilterText.toLowerCase()) ||
                                                            item.email && item.email.toLowerCase().includes(newFilterText.toLowerCase())
                                                        ));
                                                this.setState({searchValue: newFilterText, allUsers: agents});
                                            }}

                                            //onClear={this.handleClear}
                                            value={this.state.searchValue}
                                        />
                                    </Col>
                                </Row>
                                <DataTable
                                    noHeader
                                    pagination
                                    columns={columns}
                                    paginationPerPage={7}
                                    className='react-dataTable'
                                    //sortIcon={<Icon.ChevronDown size={10}/>}
                                    // paginationDefaultPage={currentPage + 1}
                                    // paginationComponent={this.CustomPagination}
                                    data={this.state.allUsers}
                                    // selectableRowsComponent={BootstrapCheckbox}
                                />
                                {this.props.chatListsLoader && <div className="text-center"><Spinner/></div>}
                            </Card>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    isAuthenticatedAdmin: state.auth.isAuthenticatedAdmin,
    agentsByRoll: state.profile.agentsByRoll,
    agentsLoader: state.profile.agentsLoader,
    chatLists: state.profile.chatLists,
    chatListsLoader: state.profile.chatListsLoader,
    user: state.auth.user
});


export default connect(mapStateToProps, {
    actionGetAgentsByRoll,
    actionDeleteUserById,
    logoutAdmin,
    getChatList,
    UpdateGroupBackend
})(Groups);